import type { Decision, RuleAction } from '@kkp-fraud/shared';
import { t } from '../i18n';

/**
 * Chips carry meaning by colour AND text — the whole set stays readable in monochrome,
 * in dark mode and for a colour-blind analyst.
 */

/** The chip colour of each action — also the fill of the action cell on an editor row. */
export const ACTION_CLASS: Record<RuleAction, string> = {
  DECLINE: 'bad',
  STEP_UP: 'warn',
  APPROVE_NOTIFY: 'info',
  ALERT_ONLY: 'mute',
  APPROVE: 'ok',
};

export function ActionChip({ action, big }: { action: RuleAction; big?: boolean }) {
  return (
    <span className={`chip ${ACTION_CLASS[action] ?? ''}${big ? ' big' : ''}`} title={t(ACTION_TITLE[action])}>
      {action}
    </span>
  );
}

/** Catalogue keys, not text: the tooltip has to follow the language switch like everything else. */
const ACTION_TITLE: Record<RuleAction, string> = {
  DECLINE: 'action.DECLINE.tooltip',
  STEP_UP: 'action.STEP_UP.tooltip',
  APPROVE_NOTIFY: 'action.APPROVE_NOTIFY.tooltip',
  ALERT_ONLY: 'action.ALERT_ONLY.tooltip',
  APPROVE: 'action.APPROVE.label',
};

export function DecisionChip({ decision, big }: { decision: Decision; big?: boolean }) {
  return <ActionChip action={decision} big={big} />;
}

export function PriorityChip({ priority }: { priority: string }) {
  return (
    <span className="chip" title={t('chip.priority.tooltip', { priority })}>
      {priority}
    </span>
  );
}

export function StateChip({ on, onLabel, offLabel }: { on: boolean; onLabel: string; offLabel: string }) {
  return <span className={`chip ${on ? 'ok' : 'mute'}`}>{on ? onLabel : offLabel}</span>;
}
